module.exports = __webpack_public_path__ + "img/Exchange.9e8a569f.svg";